import {ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot} from '@angular/router';
import {inject} from '@angular/core';
import {Store} from '@ngrx/store';
import {filter, Observable, of, take} from 'rxjs';
import {OrderDetailsActions} from 'app/order-details/state/order-details.actions';
import {selectOrder} from 'app/order-details/state/order-details.reducer';
import {Sale} from '../data/models/sale';
import {NotFoundError} from 'app/core/components/error-page/order-history-error';

export const orderResolver: ResolveFn<Observable<Sale | undefined>> = (
  route: ActivatedRouteSnapshot,
  __state: RouterStateSnapshot
) => {
  const store = inject(Store);
  const saleNumber = route.paramMap.get('saleNumber');
  if (!saleNumber) {
    store.dispatch(OrderDetailsActions.loadOrderFailure({error: new NotFoundError()}));
    return of(undefined);
  }
  store.dispatch(OrderDetailsActions.loadOrder({saleNumber: saleNumber}));
  return store.select(selectOrder).pipe(
    filter(order => order !== undefined),
    take(1)
  );
};
